import Controller from '@ember/controller';
import { action } from '@ember/object';
import { buildWaiter } from '@ember/test-waiters';
import { tracked } from '@glimmer/tracking';

const waiter = buildWaiter('global-overview-questionnaires-index-controller:update-filter-param-waiter');

type UpdateableParam = 'flow' | 'sort' | 'title';

export default class GlobalOverviewQuestionnairesIndexController extends Controller {
  queryParams = ['flow', 'sort', 'title'];

  @tracked flow = '';
  @tracked sort = 'title';
  @tracked title = '';

  @action
  updateQueryParam(key: UpdateableParam, value: string | null): void {
    if (!this.queryParams.includes(key)) return;

    // Wrapping the actual set operation in a `setTimeout` call is necessary
    // to prevent an undesired behavior where setting the filter would cause
    // the resource in Visitors::Questionnaires:List::Loader to run twice on
    // updates, kicking off two requests for the same data.
    const token = waiter.beginAsync();
    setTimeout(() => {
      this[key] = value ?? '';
      waiter.endAsync(token);
    }, 0);
  }
}
